import { render, staticRenderFns } from "./SimpleChoiceHorizontal.vue?vue&type=template&id=5a6863a7&scoped=true"
import script from "./SimpleChoiceHorizontal.vue?vue&type=script&lang=js"
export * from "./SimpleChoiceHorizontal.vue?vue&type=script&lang=js"
import style0 from "./SimpleChoiceHorizontal.vue?vue&type=style&index=0&id=5a6863a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6863a7",
  null
  
)

export default component.exports